import * as z from "zod";
import { gql } from "graphql-request";
import { Image, ImageFragment } from "../image";
import { Sys, SysFragment } from "../sys";

export const NewsEntryImageSchema = z.object({
  __typename: z.literal("NewsEntryImage"),
  sys: Sys,
  title: z.string().nullable(),
  imageNewsThumbnail: Image.nullable(),
  imageNewsThumbnailEn: Image.nullable(),
});

export const NewsEntryImage = NewsEntryImageSchema;
export type NewsEntryImage = z.infer<typeof NewsEntryImageSchema>;

export const NewsEntryImageFragment = gql`
  fragment NewsEntryImageFragment on NewsEntryImage {
    sys {
      ...SysFragment
    }
    title

    imageNewsThumbnail {
      ...ImageFragment
    }

    imageNewsThumbnailEn: imageNewsThumbnail(locale: "en") {
      ...ImageFragment
    }
  }

  ${ImageFragment}
  ${SysFragment}
`;
